import Phaser from 'phaser';
import { GAME_CONFIG } from '../config/gameConfig';

export default class Ring extends Phaser.Physics.Arcade.Sprite {
  public radius: number;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    const radius = GAME_CONFIG.ring.radius;
    super(scene, x, y, 'fish');

    this.radius = radius;

    scene.add.existing(this);

    // static をやめる（true を付けない）
    scene.physics.add.existing(this);

    this.setOrigin(0.5, 0.5);

    // 画像をリサイズせずそのまま使用
    // 画像の実際のサイズを取得
    const displayW = this.displayWidth;
    const displayH = this.displayHeight;
    const r = GAME_CONFIG.ring.radius; // コライダー半径は現状維持（40）
    
    console.log('Ring: 画像サイズ =', displayW, 'x', displayH, 'コライダー半径 =', r);

    const body = this.body as Phaser.Physics.Arcade.Body;

    // 動かないリングにする
    body.setAllowGravity(false);
    body.setImmovable(true);
    body.setVelocity(0, 0);

    // デバッグ用：設定前の値を確認
    console.log('Ring BEFORE setCircle - displaySize:', displayW, displayH, 'radius:', r, 'body.size:', body.width, body.height);
    
    // 円のコライダーを設定（半径20）
    body.setCircle(r);
    
    // デバッグ用：setCircle後の値を確認
    console.log('Ring AFTER setCircle - body.size:', body.width, body.height, 'body.radius:', body.radius);
    
    // 重要：setCircle()の後に物理ボディのサイズを画像のサイズに合わせる
    body.setSize(displayW, displayH);
    
    // 重要：setSize()を呼ぶとsetCircle()の設定がリセットされるため、再度setCircle()を呼ぶ
    body.setCircle(r);
    
    // 重要：コライダーのオフセットを画像の中心に合わせる
    // setCircle()を使う場合、オフセットを明示的に設定する必要がある
    body.setOffset(0, 0);
    
    // デバッグ用：最終的な値を確認
    console.log('Ring FINAL - body.size:', body.width, body.height, 'displaySize:', displayW, displayH, 'radius:', r, 'body.radius:', body.radius, 'body.offset:', body.offset.x, body.offset.y);
    
    body.enable = true;

    // エネルギーのdepthをライトエフェクト（20）より前に設定して、常に一定して表示されるようにする
    this.setDepth(25); // ボール（25）と同じdepthで、ライトエフェクト（20）より前
    
    // エネルギーの明るさを固定（電球のライトエフェクトの影響を受けないようにする）
    this.setAlpha(1); // 常に完全に不透明
    this.clearTint(); // 色の変更をクリア（画像の元の色を表示）
  }

  update(): void {
    // 発光エフェクトは削除済み
  }

  destroy(): void {
    super.destroy();
  }
}

